<template>
  <main id="js-page-content" role="main" class="page-content">
    <div class="row">
      <div class="subheader col-6">
        <h1 class="subheader-title">データロック</h1>
      </div>
      <!-- Right content on content header A nice area to add graphs or buttons -->
      <div class="subheader-block ml-auto demo">
        <button
          type="button"
          :disabled="btnDisable"
          class="btn btn-primary waves-effect waves-themed"
        >
          <span class="fal fa-lock-alt mr-1"></span>データロック
        </button>
        <button
          type="button"
          :disabled="btnDisable"
          class="btn btn-primary waves-effect waves-themed"
        >
          <span class="fal fa-lock-open-alt mr-1"></span>ロック解除
        </button>
      </div>
    </div>
    <!-- Your main content goes below here: -->
    <div class="row">
      <div class="col-xl-12">
        <div id="panel-1" class="panel">
          <div class="panel-hdr">
            <h2>対象</h2>
            <div class="panel-toolbar">
              <button
                class="btn btn-panel"
                data-action="panel-collapse"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Collapse"
              ></button>
              <button
                class="btn btn-panel"
                data-action="panel-fullscreen"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Fullscreen"
              ></button>
            </div>
          </div>
          <div class="panel-container show">
            <div class="loader">
              <i class="fal fa-spinner-third fa-spin-4x fs-xxl"></i>
            </div>
            <div class="panel-content contents">
              <div class="row">
                <div class="col-md-1 contTitle">処理年月</div>
                <div class="col-md-5 contCnt">{{ domProcessingDate }}</div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">状態</div>
                <div class="col-md-5 contCnt">{{ domStatus }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ------------------------------------- -->
    <!-- 成功通知モーダル -->
    <!-- 成功通知モーダル -->
    <!-- エラー確認モーダル -->
    <!-- エラー確認モーダル -->
  </main>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import Mo_modal_alert from "@/components/molecules/Mo_modal_alert.vue";

@Options({
  components: {
    Mo_modal_alert,
  },
})
export default class Datalock extends Vue {
  //----------------------
  //DOM連携用プロパティ
  //----------------------
  domProcessingDate = "-";
  domStatus = "未ロック";
  btnDisable = false;
}
</script>
